import { createRouter, createWebHistory } from 'vue-router'
import Admin from '../views/Admin.vue'
import AdminClothe from '../views/Admin/Clothe.vue'
import AdminDashboard from '../views/Admin/Dashboard.vue'
import AdminInsert from '../views/Admin/Insert.vue'
import Closet from '../views/Closet.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

const routes = [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/closet/:email',
      name: 'closet',
      component: Closet
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      children: [
        {
          path: '/admin',
          name: 'admin-dashboard',
          component: AdminDashboard,
        },
        {
          path: '/admin/clothe',
          name: 'admin-clothe',
          component: AdminClothe,
        },
        {
          path: '/admin/insert',
          name: 'admin-insert',
          component: AdminInsert,
        }
      ]
    }
  ]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
